<div class="form-row mt-4">
  <div class="form-group col-md-4">
    <label for="ad_url">AD URL</label>
    <input [(ngModel)]="configuracao.ad_url" type="text" id="ad_url" class="form-control">
  </div>
  <div class="form-group col-md-4">
    <label for="ad_dn">AD DN</label>
    <input [(ngModel)]="configuracao.ad_dn" type="text" id="ad_dn" class="form-control">
  </div>
  <div class="form-group col-md-4">
    <label for="ad_usuario">AD Usúario</label>
    <input [(ngModel)]="configuracao.ad_usuario" type="text" id="ad_usuario" class="form-control">
  </div>
  <div class="form-group col-md-4">
    <label for="ad_senha">AD Senha</label>
    <input [(ngModel)]="configuracao.ad_senha" type="text" id="ad_senha" class="form-control">
  </div>
</div>
<hr class="mt-2 mb-2" />
<div class="form-row">
  <div class="form-group col-sm-4">
    <label for="servicoCloud">Serviço de Cloud</label>
    <select [compareWith]="compareFn" id="servicoCloud" class="form-control"
      [(ngModel)]="configuracao.cloud_armazenamento">
      <option [ngValue]="null">----------------</option>
      <option *ngFor="let item of cloudArmazenamentos" [ngValue]="item.id">{{item.nome}}</option>
    </select>
  </div>
  <div class="form-group col-md-5">
    <label for="firebase_bucket">Firebase Conta de Serviço</label>
    <input [(ngModel)]="configuracao.firebase_bucket" type="text" id="firebase_bucket" class="form-control">
  </div>
</div>
<div class="form-row">
  <div class="col-sm-12">
    <label for="firebase_conta_servico">Firebase Conta de Serviço</label>
    <textarea [(ngModel)]="configuracao.firebase_conta_servico" class="form-control" id="firebase_conta_servico"
      rows="5"></textarea>
  </div>
</div>